import React from "react";

const august = [
  ["40,277", "Properties with foreclosure filings", "+13% year over year"],
  ["25,894", "Foreclosure starts", "+7% year over year"],
  ["5,794", "Completed foreclosures / REOs", "+42% year over year"],
];

const MarketData = () => (
  <>
    <section id="market" className="section bg2">
      <div className="w">
        <div className="md-badge"><span className="live-dot" />Latest ATTOM Monthly Foreclosure Data · August 2026 · Released September 17, 2026</div>
        <h2 className="h2">Latest ATTOM Monthly <em className="gold">Foreclosure Data</em></h2>
        <div className="data-grid" style={{ marginTop: "2rem" }}>
          {august.map((d) => (
            <div className="dc" key={d[1]}>
              <div className="dc-n">{d[0]}</div>
              <div className="dc-l">{d[1]}</div>
              <div className="dc-s">{d[2]}</div>
            </div>
          ))}
        </div>
        <div className="md-src">Source: <a href="https://www.attomdata.com/news/market-trends/foreclosures/" target="_blank" rel="noopener noreferrer">ATTOM August 2026 U.S. Foreclosure Market Report</a> (released September 17, 2026).</div>
        <p className="md-note">Nationwide, one in every 3,569 housing units had a foreclosure filing in August 2026 — up 1% from the prior month and 13% year over year. South Carolina, Nevada, and Florida posted the highest state foreclosure rates. Figures are reported by ATTOM and are not estimated, extrapolated, or projected.</p>
      </div>
    </section>

    <section className="section bg1">
      <div className="w">
        <div className="eyebrow">ATTOM Mid-Year 2026 · January–June 2026</div>
        <h2 className="h2">Mid-Year 2026 <em className="gold">Context</em></h2>
        <p className="lead">The 2026 mid-year ATTOM data shows foreclosure activity continuing above prior-year levels across the first half of the year, underscoring why earlier, structured borrower identification matters for servicing portfolios.</p>
        <div className="data-grid" style={{ marginTop: "2rem" }}>
          <div className="dc"><div className="dc-n">201,512</div><div className="dc-l">Total families affected — Jan–Jun 2026</div><div className="dc-s">ATTOM Mid-Year 2026 Report</div></div>
          <div className="dc"><div className="dc-n">+26%</div><div className="dc-l">Year-over-year increase (H1)</div><div className="dc-s">ATTOM Mid-Year 2026 Report</div></div>
          <div className="dc"><div className="dc-n gold">11.52%</div><div className="dc-l">FHA delinquency rate</div><div className="dc-s">MBA National Delinquency Survey</div></div>
        </div>
        <div className="md-src">Source: ATTOM Mid-Year 2026 U.S. Foreclosure Market Report · MBA National Delinquency Survey. Figures are labeled to the specific reporting period.</div>
      </div>
    </section>

    <section className="section bg2">
      <div className="w">
        <div className="eyebrow">Property Vacancy &amp; Zombie Foreclosure Context</div>
        <h2 className="h2">Vacancy &amp; Zombie <em className="gold">Foreclosure Context</em></h2>
        <p className="lead">Separately from the monthly foreclosure report, ATTOM tracks vacant and abandoned ("zombie") properties in the foreclosure pipeline. This is a distinct report and is not a monthly foreclosure total.</p>
        <div className="md-src" style={{ marginTop: "1.2rem" }}>Source: ATTOM Q3 2026 Vacant Property and Zombie Foreclosure Report — reported separately from the monthly ATTOM U.S. Foreclosure Market Report.</div>
      </div>
    </section>
  </>
);

export default MarketData;
